module.exports = __webpack_public_path__ + "static/Gotham-Book-6b05a5678e2f0578efd5f82c0898f99a.woff2";